// extracted by mini-css-extract-plugin
module.exports = {"impressionButton":"styles_impressionButton__3siAG","editIcon":"styles_editIcon__2Af77"};